/**
 * Navbar item configuration used across all persona components
 * Centralizes the navbar configuration to avoid duplication in templates
 */
export interface NavbarItem {
  id: string;
  label: string;
  selectedIcon: string;
  unselectedIcon: string;
}

/**
 * Standard navbar items used across the application
 */
export const PERSONA_NAVBAR_ITEMS: NavbarItem[] = [
  { 
    id: 'profile', 
    label: 'Profile', 
    selectedIcon: '/assets/images/Person_Selected.png', 
    unselectedIcon: '/assets/images/Person_Unselected.png' 
  },
  { 
    id: 'home', 
    label: 'Homepage', 
    selectedIcon: '/assets/images/Home_Selected.png', 
    unselectedIcon: '/assets/images/Home_Unselected.png' 
  },
  { 
    id: 'contacts', 
    label: 'Contacts', 
    selectedIcon: '/assets/images/Contact_Selected.png', 
    unselectedIcon: '/assets/images/Contact_Unselected.png' 
  }
];

/**
 * Selected IDs for different pages
 */
export const NAVBAR_SELECTED_IDS = {
  HOME: 'home',
  PROFILE: 'profile',
  CONTACTS: 'contacts'
} as const;
